<template>
  <div ref="slider" class="slider">
    <div ref="sliderGroup" class="slider-group">
      <slot />
    </div>
    <div class="dots">
      <span v-for="(item,index) in dots" :key="index" class="dot" :class="{active : currentPageIndex=== index}" />
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import { addClass } from '../../utils/commonDom'

export default {
  name: 'Slider',
  props: {
    loop: { // 是否循环轮播
      type: Boolean,
      default: true
    },
    autoPlay: { // 是否自动轮播
      type: Boolean,
      default: true
    },
    interval: { // 轮播间隔
      type: Number,
      default: 4000
    }
  },
  data() {
    return {
      dots: [],
      currentPageIndex: 0
    }
  },
  mounted() {
    setTimeout(() => { // 浏览器刷新17ms一次
      this.setSliderWidth()
      this.initDots()
      this.initSlider()

      if (this.autoPlay) {
        this.setAutoPlay()
      }
    }, 20)

    window.addEventListener('resize', () => {
      if (!this.slider) {
        return
      }
      this.setSliderWidth(true)
      this.slider.refresh()
    })
  },
  destroyed() {
    clearTimeout(this.timer)
  },
  methods: {
    setSliderWidth(isResize) { // 设置slider宽度
      this.children = this.$refs.sliderGroup.children
      let width = 0
      const sliderWidth = this.$refs.slider.clientWidth
      for (let i = 0; i < this.children.length; i++) {
        const child = this.children[i]
        addClass(child, 'slider-item')

        child.style.width = sliderWidth + 'px'
        width += sliderWidth
      }

      if (this.loop && !isResize) { // 如果循环轮播 则宽度是原来的2倍
        width += 2 * sliderWidth
      }
      this.$refs.sliderGroup.style.width = width + 'px'
    },

    initDots() {
      this.dots = new Array(this.children.length)
    },

    initSlider() { // 初始化滚动插件
      this.slider = new BScroll(this.$refs.slider, {
        scrollX: true,
        scrollY: false,
        momentum: false, // 快速滚动时不开启滑动惯性
        snap: true,
        snapLoop: this.loop,
        snapThreshold: 0.3, // 滚动距离超过宽度/高度的 30% 时切换图片
        snapSpeed: 400 // 切换动画时长 400ms
      })

      this.slider.on('scrollEnd', () => {
        let pageIndex = this.slider.getCurrentPage().pageX
        if (this.loop) {
          pageIndex -= 1
        }
        this.currentPageIndex = pageIndex
        if (this.autoPlay) {
          clearTimeout(this.timer)
          this.setAutoPlay()
        }
      })
    },

    setAutoPlay() { // 自动轮播
      let pageIndex = this.currentPageIndex + 1
      if (this.loop) { // 循环轮播
        pageIndex += 1
      }
      this.timer = setTimeout(() => {
        this.slider.goToPage(pageIndex, 0, 400)
      }, this.interval)
    }

  }
}
</script>

<style lang="less" scoped>
.slider{
  min-height: 1px;
   position: relative;

  .slider-group{
    overflow: hidden;
    white-space: nowrap;
    position: relative;

    .slider-item{
      float: left;
      box-sizing: border-box;
      overflow: hidden;
      text-align: center;

      a{
        display: block;
        width: 100%;
        overflow: hidden;
        text-decoration: none;
      }

      img{
        display: block;
        width: 100%;
      }
    }
  }
  .dots{
      position: absolute;
      right: 0;
      left: 0;
      bottom: 2px;
      text-align: center;
      font-size: 0;

      .dot{
        display: inline-block;
        margin: 0 4px;
        width:8px;
        height: 8px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.5);
      }

      .active{
        width: 20px;
        border-radius: 5px;
        background: rgba(0, 0, 0, 0.8);
      }
    }
}
</style>
